import { render } from "./TabBodyForecast.vue?vue&type=template&id=3f847158&scoped=true"
import script from "./TabBodyForecast.vue?vue&type=script&lang=js"
export * from "./TabBodyForecast.vue?vue&type=script&lang=js"

import "./TabBodyForecast.vue?vue&type=style&index=0&id=3f847158&scoped=true&lang=css"

import exportComponent from "/home/manohar/Bhutan_gitlab/tethysapp-airqualitybt/tethysapp/airqualitybt/vairqualitybt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f847158"]])

export default __exports__